export const API_STATIC = "https://api.octapharma.bakasable.fr/api/static/" 
